import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

export default function CategorySpendCard() {
  const chartRef = useRef(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    if (chartRef.current && typeof window.finCategoryChart !== 'undefined') {
      window.finCategoryChart.canvas = chartRef.current;
      window.finCategoryChart.ctx = chartRef.current.getContext('2d');
      document.getElementById('finCategory').chart = window.finCategoryChart;
    }
  }, []);

  return (
    <Box className="card" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title" id="finCategoryTitle">Spend by category — Aug</h3>
      </div>
      <div className="chart-wrap" style={{ height: '240px' }}>
        <canvas id="finCategory" ref={chartRef}></canvas>
      </div>
    </Box>
  );
}
